import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  SUBJECT: '[data-fragment="ForumSearchHighlight.subject"]',
  BODY: '[data-fragment="ForumSearchHighlight.body"]',
};

class ForumSearchHighlight extends WebComponent {
  constructor(props) {
    super(props);
    this.highlight = this.highlight.bind(this);
  }

  didMount() {
    this.searchInput = this.element.querySelector('#searchPost');
    this.subjects = this.element.querySelectorAll(fragments.SUBJECT);
    this.bodies = this.element.querySelectorAll(fragments.BODY);
    this.openedThreads = [];

    if (this.searchInput.value !== '') {
      this.highlight(this.searchInput.value, this.subjects);
      this.highlight(this.searchInput.value, this.bodies);
    }
  }

  highlight(query, elements) {
    const self = this;
    elements.forEach((item) => {
      // if in thread, then show
      if (item.dataset.thread && item.innerHTML.toLowerCase().indexOf(query.toLowerCase()) !== -1) {
        const openAnswersButton = self.element.querySelector(`#button-answer-${item.dataset.thread}`);
        if (openAnswersButton) {
          window.setTimeout(() => {
            if (!self.openedThreads.includes(item.dataset.thread)) {
              self.openedThreads.push(item.dataset.thread);
              openAnswersButton.click();
            }
          }, 200);
        }
      }
      // first store images src
      let images = item.querySelectorAll('img');
      const imagesData = [];
      images.forEach((image) => {
        imagesData.push(image.src);
        image.src = '#';
      });
      // do replace
      const text = item.innerHTML;
      const replace = `(${query})`;
      const re = new RegExp(replace, 'gi');
      const highlightedText = text.replace(re, '<span class="fulltext-match">$1</span>');
      item.innerHTML = highlightedText;
      // revert images src
      images = item.querySelectorAll('img');
      images.forEach((image, index) => {
        image.src = imagesData[index];
      });
    });
  }
}

export default ForumSearchHighlight;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ForumSearchHighlight.js